const mapContentPayload = ({
  content: {
    body,
    html,
    pk,
    sk,
    image,
    generateLocationIdAttempt,
    ...rest
  }
}) => ({ content: rest })

export {
  mapContentPayload
}
